import { getFunctions, httpsCallable } from 'firebase/functions';
import { FirebaseHandlers } from '../../../../core/firebase';
import { IMessageInstance } from '../../schemas';

const functions = getFunctions();
const textFn: any = httpsCallable(functions, 'messaging-text');
const conversationFn: any = httpsCallable(functions, 'messaging-conversation');

export interface ITestInput {
  uid: string;
  body: string;
  phone: string;
  messageID: string;
  dogDaysOld?: number;
}


export const sendMessage = async (usersUid: string, body: string, phone: string, messageID: string, dogDaysOld: number): Promise<void> => {
  await FirebaseHandlers.run<ITestInput, void>({uid: usersUid, body, phone, messageID, dogDaysOld}, textFn);
};

export const getConversation = async (phone: string): Promise<IMessageInstance[]> => {
  return FirebaseHandlers.run<{phone: string}, IMessageInstance[]>({phone: phone}, conversationFn);
}
